<div class="flex flex-column min-h-screen pb-6">
    <div class="bg-blue-sara h-4rem flex justify-content-between px-3">
        <div class="align-content-center align-items-center">
            <img src="assets/icons/secure-data/SecureDataLogo.png" alt="Sara Plus Logo" class="w-3rem h-3rem">
        </div>
        <div class="flex-1 align-content-center align-items-center flex justify-content-start">
            <div class="pl-3">
                <span class="login-header">
                    <app-translate key="SECURE_DATA_ENTRY"></app-translate>
                </span>
            </div>
        </div>
        <div class="flex align-content-center align-items-center">
            <app-language-selector></app-language-selector>
        </div>
    </div>
    <div class="p-3 flex-1 justify-content-center align-content-center">
        <ng-content></ng-content>
    </div>
    <div>
        <app-footer></app-footer>
    </div>
</div>